import axios from 'axios'
import { getKeyTypePair } from '../../graphql/queries'
import { getAwsConfig } from '../../aws-exports'
import { UserAttributes, UserAttributesResp } from '../../store/user/interfaces'

const awsConfig = getAwsConfig()

export const getUserAttributes = (
  userId: number,
  token: string
): Promise<UserAttributes> => {
  const graphQL = {
    query: getKeyTypePair,
    variables: { type: 'get', key: `user:${userId}` },
  }
  return axios
    .post<UserAttributesResp>(awsConfig.aws_appsync_graphqlEndpoint, graphQL, {
      headers: {
        Authorization: token,
      },
    })
    .then((resp) => {
      return JSON.parse(resp.data.data.get.result) as UserAttributes
    })
}
